import ErrorTooltip from 'Components/ErrorTooltip';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import env from 'environment_system/env_system';
import { Field, FieldProps, useFormikContext } from 'formik';
import { checkValidObject, saveEditForm } from 'GenericForms/Helper';
import React, { useEffect } from 'react'
import { Button, CardBody, CardFooter, Col, Input, Label, Row, Form } from 'reactstrap';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';
interface FreshWaterStructureProps {
    FreshWaterFormik: any;
    toggleDynamicTabs: any;
    setErrorMessage: any;
    formRefresh: number;
    setFormRefresh: (value: number) => void;
    calculateFreshWaterROB: any;
    setEditValues?: any;
    editValues?: any;
    refreshKey: number;
    setRefreshKey: any;
    editInitialValues?: any;
    editSubmit?: any;
    editIsSubmitting?: any
}

const FreshWaterStructure = ({
    FreshWaterFormik,
    toggleDynamicTabs,
    setErrorMessage,
    formRefresh,
    calculateFreshWaterROB,
    setEditValues,
    editValues,
    editSubmit,
    editIsSubmitting,
}: FreshWaterStructureProps) => {
    /** State variables */
    const { previousEnggTabIndex, editReportBool, setPreviousTabIndex, discardwarning } = useEditReport();
    const { values, errors, touched, handleChange, handleBlur, isSubmitting, resetForm, setErrors, handleSubmit, validateForm, setFieldTouched }:
        { values: any, errors: any, touched: any, handleChange: any, handleBlur: any, isSubmitting: any, resetForm: any, setErrors: any, handleSubmit: any, validateForm: any, setFieldTouched: any } = useFormikContext<any>();
    /** State variables end */

    /** useEffect */
    useEffect(() => {
        if (checkValidObject(editValues?.chief_engineer?.fresh_water)) {
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues?.chief_engineer,
                    fresh_water: values
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values])
    /** useEffect end */
    return (
        <Form onSubmit={handleSubmit} autoComplete="off" noValidate>
            <CardBody className="engineer-card-body">
                <Row lg={12}>
                    <Col lg={8} className="mb-1">
                        <Row lg={12} className="pb-2 pt-1">
                            <Col lg={6}>
                                <Label
                                    className="asteric mb-0"
                                    for="amount_of_fresh_water_produced"
                                >
                                    Amount of fresh water produced
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="amount_of_fresh_water_produced_msg"
                                    ></i>
                                </Label>
                                <ToolTip
                                    target="amount_of_fresh_water_produced_msg"
                                    message={`${TooltipMsg.Fresh_Water.filter(
                                        (item: any) =>
                                            item.target ===
                                            "amount_of_fresh_water_produced_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <div className="input-group">
                                    <Field name={"amount_of_fresh_water_produced"}>
                                        {({ field, form }: FieldProps) => (
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type="text"
                                                className="form-control text-right max-width-7"
                                                id="amount_of_fresh_water_produced"
                                                name={field.name}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                onBlur={(e: any) => {
                                                    handleBlur(e);
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                defaultValue={
                                                    values?.amount_of_fresh_water_produced
                                                }
                                                autoFocus={true}
                                            />
                                        )}
                                    </Field>
                                    <div className="input-group-text round_border">
                                        mt
                                    </div>
                                </div>
                                {touched?.amount_of_fresh_water_produced &&
                                    errors?.amount_of_fresh_water_produced &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target={`amount_of_fresh_water_produced`}
                                            message={errors?.amount_of_fresh_water_produced}
                                            open={
                                                errors?.amount_of_fresh_water_produced
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </Col>
                            <Col lg={6}>
                                <Label
                                    className="asteric mb-0"
                                    for="amount_of_fresh_water_received"
                                >
                                    Amount of fresh water received
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="amount_of_fresh_water_received_msg"
                                    ></i>
                                </Label>
                                <ToolTip
                                    target="amount_of_fresh_water_received_msg"
                                    message={`${TooltipMsg.Fresh_Water.filter(
                                        (item: any) =>
                                            item.target ===
                                            "amount_of_fresh_water_received_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <div className="input-group">
                                    <Field name={"amount_of_fresh_water_received"}>
                                        {({ field, form }: FieldProps) => (
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type="text"
                                                className="form-control text-right max-width-7"
                                                id="amount_of_fresh_water_received"
                                                name={field.name}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                onBlur={(e: any) => {
                                                    handleBlur(e);
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                defaultValue={
                                                    values?.amount_of_fresh_water_received
                                                }
                                            />
                                        )}
                                    </Field>
                                    <div className="input-group-text round_border">
                                        mt
                                    </div>
                                </div>
                                {touched?.amount_of_fresh_water_received &&
                                    errors?.amount_of_fresh_water_received &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target={`amount_of_fresh_water_received`}
                                            message={errors?.amount_of_fresh_water_received}
                                            open={
                                                errors?.amount_of_fresh_water_received
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </Col>
                        </Row>
                        <Row lg={12}>
                            <Col lg={6}>
                                <Label
                                    className="mb-0 label-w-20 asteric"
                                    for="amount_of_domestic_water_consumed"
                                >
                                    Amount of domestic water consumed
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="amount_of_domestic_water_consumed_msg"
                                    ></i>
                                </Label>
                                <ToolTip
                                    target="amount_of_domestic_water_consumed_msg"
                                    message={`${TooltipMsg.Fresh_Water.filter(
                                        (item: any) =>
                                            item.target ===
                                            "amount_of_domestic_water_consumed_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <div className="input-group">
                                    <Field name={"amount_of_domestic_water_consumed"}>
                                        {({ field, form }: FieldProps) => (
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type="text"
                                                className="form-control text-right max-width-7"
                                                id="amount_of_domestic_water_consumed"
                                                name={field.name}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                onBlur={(e: any) => {
                                                    handleBlur(e);
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                defaultValue={
                                                    values?.amount_of_domestic_water_consumed
                                                }
                                            />
                                        )}
                                    </Field>
                                    <div className="input-group-text round_border">
                                        mt
                                    </div>
                                </div>
                                {touched?.amount_of_domestic_water_consumed &&
                                    errors?.amount_of_domestic_water_consumed &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target={`amount_of_domestic_water_consumed`}
                                            message={
                                                errors?.amount_of_domestic_water_consumed
                                            }
                                            open={
                                                errors?.amount_of_domestic_water_consumed
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </Col>
                            <Col lg={6}>
                                <Label
                                    className="mb-0 label-w-20 asteric"
                                    for="amount_of_distilled_water_consumed"
                                >
                                    Amount of distilled water consumed
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="amount_of_distilled_water_consumed_msg"
                                    ></i>
                                </Label>
                                <ToolTip
                                    target="amount_of_distilled_water_consumed_msg"
                                    message={`${TooltipMsg.Fresh_Water.filter(
                                        (item: any) =>
                                            item.target ===
                                            "amount_of_distilled_water_consumed_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <div className="input-group">
                                    <Field name={"amount_of_distilled_water_consumed"}>
                                        {({ field, form }: FieldProps) => (
                                            <Input
                                                onFocus={(e) => e.target.select()}
                                                type="text"
                                                className="form-control text-right max-width-7"
                                                id="amount_of_distilled_water_consumed"
                                                name={field.name}
                                                onChange={(e: any) => {
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                onBlur={(e: any) => {
                                                    handleBlur(e);
                                                    handleChange(e);
                                                    calculateFreshWaterROB(
                                                        e,
                                                        values,
                                                        form,
                                                        field.name
                                                    );
                                                }}
                                                defaultValue={
                                                    values?.amount_of_distilled_water_consumed
                                                }
                                            />
                                        )}
                                    </Field>
                                    <div className="input-group-text round_border">
                                        mt
                                    </div>
                                </div>
                                {touched?.amount_of_distilled_water_consumed &&
                                    errors?.amount_of_distilled_water_consumed &&
                                    env?.form_validation === true && !discardwarning && (
                                        <ErrorTooltip
                                            target={`amount_of_distilled_water_consumed`}
                                            message={
                                                errors?.amount_of_distilled_water_consumed
                                            }
                                            open={
                                                errors?.amount_of_distilled_water_consumed
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </Col>
                        </Row>
                    </Col>
                    <Col
                        className="d-flex align-items-center justify-content-center"
                        sm={4}
                    >
                        <div
                            className=
                            "badge-soft-info fresh_Water_Card d-flex flex-column align-items-center justify-content-center max-h-7 batch-bg-color"
                            key={formRefresh}
                        >
                            <div className="p-1">
                                <Label className="mb-0 font-large">
                                    Fresh Water ROB
                                </Label>
                            </div>
                            <div className="p-1">
                                <strong className="waterROBlbl mb-0" id="fresh_water_rob">
                                    {Number.isNaN(parseFloat(values?.rob)) ? 0 : values?.rob}&nbsp;
                                    mt
                                </strong>
                            </div>
                        </div>
                        {errors?.rob && values?.rob && parseFloat(values?.rob) < 0 && document.getElementById('fresh_water_rob') &&
                            env?.form_validation === true && !discardwarning && (
                                <ErrorTooltip
                                    target={`fresh_water_rob`}
                                    message={
                                        errors?.rob
                                    }
                                    open={
                                        errors?.rob
                                            ? true
                                            : false
                                    }
                                />
                            )}
                    </Col>
                </Row>
            </CardBody>
            <CardFooter className="p-2 py-3">
                <Row className="d-flex align-items-center flex-row-reverse">
                    <Col lg={10}>
                        <div className="d-flex flex-wrap gap-3 justify_right">
                            {/* {editReportBool &&
                                <Button
                                    type="reset"
                                    color="danger"
                                    className="btn_size_cstm"
                                    onClick={() => {
                                        setEditValues({
                                            ...editValues,
                                            chief_engineer: {
                                                ...editValues?.chief_engineer,
                                                fresh_water: editInitialValues?.chief_engineer?.fresh_water,
                                            }
                                        })
                                        setRefreshKey(refreshKey + 1);
                                        setFormRefresh(formRefresh + 1);
                                    }}
                                >
                                    Reset
                                </Button>
                            } */}
                            <Button
                                type={editReportBool ? "button" : "submit"}
                                color="primary"
                                className="btn_size_cstm"
                                disabled={isSubmitting || editIsSubmitting}
                                onClick={async () => {
                                    const validationErrors = await validateForm();
                                    Object.keys(values || {}).forEach((key) => {
                                        setFieldTouched(key, true, false);
                                    });
                                    if (editReportBool && Object.keys(validationErrors).length === 0) {
                                        await saveEditForm(
                                            editSubmit,
                                            toggleDynamicTabs,
                                            previousEnggTabIndex,
                                            setPreviousTabIndex
                                        );
                                    }
                                }}
                            >
                                {(isSubmitting || editIsSubmitting) && (
                                    <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                )}
                                Next <i className="bx bx-chevron-right ms-1" />
                            </Button>
                        </div>
                    </Col>
                    <Col lg={2}>
                        <Button
                            type="button"
                            color="primary"
                            className="btn_size_cstm"
                            onClick={() => {
                                setErrorMessage(null);
                                if (!editReportBool) {
                                    setErrors({});
                                    resetForm();
                                }
                                toggleDynamicTabs(previousEnggTabIndex - 1);
                            }}
                        >
                            <i className="bx bx-chevron-left me-1" /> Previous
                        </Button>
                    </Col>
                </Row>
            </CardFooter>
            <FormValuesDebug
                values={[
                    values,
                    errors,
                    FreshWaterFormik.initialValues,
                    touched,
                ]}
            />
        </Form>
    )
}

export default FreshWaterStructure